import React from 'react';
import { Typography, Image } from 'tfc-components';

import image from 'assets/images/home/whywork.png';
import Icon from 'components/atoms/Icon';
import Section from 'components/organisms/Section';

const WhyWork: React.FC = () => (
  <Section>
    <div className="p-home_whoWeAre p-home_whoWeAre-reverse">
      <div className="p-home_whyWork_image">
        <Image imgSrc={image} alt="Who we are" ratio={580 / 262} />
      </div>
      <div className="p-home_features_content">
        <Section.Title left small>Why Companies Work With Us</Section.Title>
        <Typography.Text extendClasses="p-home_whoWeAre_text">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Donec in est eros. Donec porttitor ligula ut Lorem ipsum dolor sit amet,
          consectetur adipiscing elit. Donec in est eros. Donec porttitor ligula ut
        </Typography.Text>
        <ul className="p-home_whoWeAre_list">
          <li>
            <Icon iconName="checkOrange" size="24" />
            <Typography.Text>AI-first expertise</Typography.Text>
          </li>
          <li>
            <Icon iconName="checkOrange" size="24" />
            <Typography.Text>Real product-market fit focus</Typography.Text>
          </li>
          <li>
            <Icon iconName="checkOrange" size="24" />
            <Typography.Text>Transparent, iterative process</Typography.Text>
          </li>
          <li>
            <Icon iconName="checkOrange" size="24" />
            <Typography.Text>
              Proven ability to turn prototypes into revenue-ready products
            </Typography.Text>
          </li>
        </ul>
      </div>
    </div>
  </Section>
);

export default WhyWork;
